import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../../../dto/data-model.js';
import { AuditLogEntry } from '../../audit-log-entry.js';
import { OnlineEventTicketOrder } from '../../../online-event-ticket-order.js';
import { MapUtils } from '../../../../../utility/map-utils.js';
import {
  cloneData, isSameData,
} from '../../../../dto/data-model-utils.js';
import { AuditLogEntryType } from '../../audit-log-entry-type.js';

export class OnlineEventTicketOrderRefundedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = 'bc5d52f42b4e43338130d8408c6d37c5';

  private constructor(
    public readonly before: OnlineEventTicketOrder,
    public readonly after: OnlineEventTicketOrder,
  ) {
    super();
  }

  get $typeId(): string {
    return OnlineEventTicketOrderRefundedEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.OnlineEventTicketOrderRefunded;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      eventId: this.after.eventId,
      orderId: this.after.uniqueId,
      customerId: this.after.creatorId,
      isGuestOrder: this.after.isGuestOrder,
    };
  }

  static create(args: {
    before: OnlineEventTicketOrder,
    after: OnlineEventTicketOrder,
  }): OnlineEventTicketOrderRefundedEntry {
    return new OnlineEventTicketOrderRefundedEntry(
        args.before,
        args.after,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OnlineEventTicketOrderRefundedEntry {
    return this.create({
      before: context.fromData(MapUtils.getRecord(map, 'before')),
      after: context.fromData(MapUtils.getRecord(map, 'after')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      before: context.toData(this.before),
      after: context.toData(this.after),
    };
  }

  clone(): this {
    return OnlineEventTicketOrderRefundedEntry.create({
      before: cloneData(this.before),
      after: cloneData(this.after),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.before, this.before) &&
          isSameData(other.after, this.after);
  }
}

export class OnlineEventTicketOrderRefundedEntryBuilder extends DataModelBuilder<OnlineEventTicketOrderRefundedEntry> {
  build(context: SerializationContext, map: SerializedData): OnlineEventTicketOrderRefundedEntry {
    return OnlineEventTicketOrderRefundedEntry.fromMap(context, map);
  }
}
